/**
 * GET `admin/reports/clinics` — платформенный свод по клиникам (экран выбора
 * клиники): нетто кассы, долги, приёмы, врачи, пациенты за период.
 */

import {apiEnabled, http} from '@services/utils';

import {MOCK_CLINICS_REPORT} from '../mocks';
import {arr, asNum, asObj, asStr, type Raw, toSom} from '../raw.utils';
import type {ClinicsReport, ReportPeriod} from '../types';

const sleep = (ms: number) => new Promise((r) => setTimeout(r, ms));

export const getClinicsReport = async (period: ReportPeriod): Promise<ClinicsReport> => {
  if (!apiEnabled) {
    await sleep(280);
    return structuredClone(MOCK_CLINICS_REPORT);
  }

  const raw = await http<Raw>('admin/reports/clinics', {
    params: {period},
    skipCaseConversion: true,
  });
  return {
    dateFrom: typeof raw.dateFrom === 'string' ? raw.dateFrom : null,
    dateTo: asStr(raw.dateTo),
    totalRevenueNet: toSom(raw.totalRevenueNetTiyin),
    totalDebt: toSom(raw.totalDebtTiyin),
    rows: arr(raw.rows).map((v) => {
      const r = asObj(v);
      return {
        clinicId: asStr(r.clinicId),
        name: asStr(r.name),
        cityName: typeof r.cityName === 'string' && r.cityName !== '' ? r.cityName : '—',
        revenueNet: toSom(r.revenueNetTiyin),
        debt: toSom(r.debtTiyin),
        appointments: asNum(r.appointments),
        completed: asNum(r.completed),
        doctors: asNum(r.doctors),
        patients: asNum(r.patients),
      };
    }),
  };
};
